// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__QECQP","Success":"Button_Success__27HWx","Danger":"Button_Danger__2L711"};